import * as NotificationActions from "./notification";

export const dispatchError = dispatch => (e, hide = true) =>
    dispatch(NotificationActions.error((e.response && e.response.data && e.response.data.error) || "Oops, something went wrong!", hide));

export const notifyError = dispatch => e => {
    dispatchError(dispatch)(e);
    throw e;
};
